module.exports = __webpack_public_path__ + "img/deal.533e3c29.svg";